var BookmarkButton     = require("app/Bookmarks/BookmarkButton"),
    HyperLinkSupport   = require("enyo-ui/HyperLinkSupport"),
    IconButton         = require("app/ui/IconButton"),
    Layout             = require("./AlbumTrackLayout"),
    PlayPauseNavButton = require("app/MediaPlayer/PlayPauseNavButton"),
    ShareButton        = require("app/Sharing/ShareButton"),
    ThumbnailImage     = require("app/ui/thumbnails/ThumbnailImage"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    get                = require("object-path").get,
    icons              = require("app/theme/icons"),
    kind               = require("enyo/kind"),
    onHyperlinkTap     = require("app/utils/onHyperlinkTap");

require("./AlbumTrack.less");
require("app/theme/IconButton--play-pause.less");

module.exports = kind(/** @lends  app.MusicAlbumPage.AlbumTrack.prototype */ {

    /**
     * @private
     */
    name: "app.MusicAlbumPage.AlbumTrack",

    /**
     * @private
     */
    classes: "app-music-album-page-album-track",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        classes:    "app-music-album-page-album-track__container",
        components: [{
            name:       "thumbnail",
            kind:       ThumbnailImage,
            classes:    "app-music-album-page-album-track__thumbnail",
            formFactor: "square",
            ontap:      "onThumbnailTap"
        }, {
            classes:    "app-music-album-page-album-track__header",
            components: [{
                name:    "playPauseNavButton",
                classes: "app-music-album-page-album-track__play-pause-nav-button",
                kind:    PlayPauseNavButton,
                theme:   "play-pause"
            }, {
                classes:    "app-music-album-page-album-track__title-wrapper",
                components: [{
                    name:    "title",
                    classes: "app-music-album-page-album-track__title",
                    tag:     "h2"
                }, {
                    name:    "artists",
                    classes: "app-music-album-page-album-track__artists"
                }]
            }]
        }, {
            classes:    "app-music-album-page-album-track__buttons",
            components: [{
                name:        "infoButton",
                kind:        IconButton,
                classes:     "app-music-album-page-album-track__info-button",
                mixins:      [HyperLinkSupport],
                icon:        icons["app.MusicAlbumPage.AlbumTrack.infoIcon"],
                showCaption: false,
                theme:       "icon-white",
                ontap:       "onHyperlinkTap"
            }, {
                name:        "bookmarkButton",
                kind:        BookmarkButton,
                classes:     "app-music-album-page-album-track__bookmark-button",
                showCaption: false,
                theme:       "icon-white"
            }, {
                name:        "shareButton",
                kind:        ShareButton,
                classes:     "app-music-album-page-album-track__share-button",
                showCaption: false,
                theme:       "icon-white"
            }]
        }, {
            classes:    "app-music-album-page-album-track__description",
            components: [{
                name:      "body",
                allowHtml: true,
                classes:   "app-music-album-page-album-track__body"
            }]
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            data        = this.data || {},
            artists     = get(data, "artists", []),
            infoLink    = get(data, "links.details", null),
            $artists    = this.$.artists,
            $thumbnail  = this.$.thumbnail,
            $infoButton = this.$.infoButton;

        $thumbnail.set("data", data || null);
        $thumbnail.set("caption", i18nService.getString("app.MusicAlbumPage.AlbumTrack.PlayButton.caption"));
        $thumbnail.set("tooltip", i18nService.getString("app.MusicAlbumPage.AlbumTrack.PlayButton.tooltip"));
        $thumbnail.set("icon", icons["app.MusicAlbumPage.AlbumTrack.playIcon"]);
        this.$.playPauseNavButton.set("mediaItem", data);

        if (artists.length > 0) {
            $artists.set("showing", true);
            $artists.set("content", artists.join(", "));
        }
        else {
            $artists.set("showing", false);
            $artists.set("content", "");
        }
        this.$.title.set("content", get(data, "meta.title", null) || "");
        this.$.bookmarkButton.set("mediaItem", data || null);
        this.$.shareButton.set("mediaItem", data || null);
        this.$.body.set("content", get(data, "meta.html_long_description", null) || "");
        $infoButton.set("tooltip", i18nService.getString("app.MusicAlbumPage.AlbumTrack.InfoButton.tooltip"));
        $infoButton.set("href", infoLink);

        this.resize();
    },

    /**
     * Forward tabs on thumbnail to play button
     *
     * @private
     */
    onThumbnailTap: function() {
        this.$.playPauseNavButton.onHyperlinkTap();
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap

});
